import { IsObject } from 'class-validator';
import { BaseDto } from '../base.dto';

/** The `{ data, outputs }` blob produced by the dynamic form renderer. */
export class FormSubmissionBlobDto {
  @IsObject()
  data: Record<string, unknown>;

  @IsObject()
  outputs: Record<string, unknown>;
}

export class FormSubmissionDto extends BaseDto {
  /** The exact template version the submission is pinned to. */
  formTemplateVersionId: string;
  /** @deprecated Use formTemplateVersionId */
  formTemplateId?: string;
  submission: FormSubmissionBlobDto;
  draft: boolean;
}
